import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=1fda2f0e&scoped=true&"
import script from "./DragDrop.vue?vue&type=script&lang=js&"
export * from "./DragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda2f0e",
  null
  
)

export default component.exports